export const DATADOG_APP_ID = process.env.NEXT_PUBLIC_DATADOG_APP_ID;
export const DATADOG_CLIENT_TOKEN = process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN;
export const DATADOG_SITE = process.env.NEXT_PUBLIC_DATADOG_SITE;
export const DATADOG_SERVICE = process.env.NEXT_PUBLIC_DATADOG_SERVICE;
export const DATADOG_ENV = process.env.NEXT_PUBLIC_DATADOG_ENV;
export const DATADOG_VERSION = process.env.NEXT_PUBLIC_DATADOG_VERSION;
export const DATADOG_DEFAULTPRIVACYLEVEL = 'mask-user-input';
export const DATADOG_ALLOWTRACINGURL = process.env.NEXT_PUBLIC_DATADOG_ALLOWTRACINGURL;
export const DATADOG_PRODUCT = process.env.NEXT_PUBLIC_DATADOG_PRODUCT;

export const SESSIONSAMPLERATE = 100;
export const SESSIONREPLAYSAMPLERATE = 20;
export const TRACKUSERINTERACTIONS =
  process.env.NEXT_PUBLIC_DATADOG_TRACKUSERINTERACTIONS === 'true';
export const TRACKRESOURCES =
  process.env.NEXT_PUBLIC_DATADOG_TRACKRESOURCES === 'true';
export const TRACKLONGTASKS =
  process.env.NEXT_PUBLIC_DATADOG_TRACKLONGTASKS === 'true';
export const FORWARDERRORSTOLOGS =
  process.env.NEXT_PUBLIC_DATADOG_FORWARDERRORSTOLOGS === 'true';
